<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on }">
      <span
        v-on="isLoading?false:on"
        class="pointer"
        :style="{
            opacity: (isLoading)?0.5:1
          }"
        :title="lang($store, `sap/listings.global.filter.order_statuses.${value}`)"
      >
        {{ORDER_STATUS_ICONS[value]?ORDER_STATUS_ICONS[value]:'?'}}
      </span>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, key) in items"
        :key="key"
        @click="updateValue(key)"
      >
        <v-list-item-title :title="item.title">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
/* constants */
import * as orderStatuses from '../../constants/order_statuses';
import { ORDER_STATUS_ICONS } from '../../constants/order_statuses_data';

export default {
  name: 'OrderStatus',
  props: {
    value: {
      type: String,
      default: orderStatuses.ORDERED,
    },
    updateRequest: {
      type: Function,
      default: () => () => {
      },
    },
  },
  data() {
    const statuses = {};
    // eslint-disable-next-line no-unused-vars
    Object.entries(orderStatuses)
      .forEach(([key, value]) => {
        statuses[value] = {
          title: this.lang(this.$store, `sap/listings.global.filter.order_statuses.${value}`),
          text: ORDER_STATUS_ICONS[value],
        };
      });

    return {
      orderStatuses,
      ORDER_STATUS_ICONS,
      items: statuses,
      isLoading: false,
    };
  },
  methods: {
    updateValue(value) {
      const oldValue = this.value;
      this.$emit('updated', value);
      this.isLoading = true;
      setTimeout(() => {
        this.updateRequest(value)
          .catch((error) => {
            this.$emit('updated', oldValue);
            console.error(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }, 0);
    },
  },
};
</script>

<style scoped>

</style>
